<template>
	<div class="wrapper tw-flex tw-flex-col tw-min-h-screen">
		<side-bar>
			<template slot="links">
				<sidebar-item v-for="route in roleRoutes" :key="route.name" :link="route"></sidebar-item>
			</template>
			<template #actions>
				<base-button
					:disabled="isLoggingOut"
					:loading="isLoggingOut"
					type="primary"
					class="tw-flex tw-space-x-1 tw-items-center"
					@click="onClickLogout"
				>
					<b-icon icon="box-arrow-left" class="tw-font-bold"></b-icon>
					<span>Logout</span>
				</base-button>
			</template>
		</side-bar>
		<main
			class="main-content tw-bg-gradient-to-b tw-flex-1 tw-flex tw-flex-col"
			:class="{
				'tw-from-green-50 tw-to-green-800': $isAdmin,
				'tw-from-indigo-50 tw-to-indigo-800': $isClient,
				'tw-from-blue-50 tw-to-blue-800': $isExpertAdmin,
				'tw-from-red-50 tw-to-red-800': $isExpertClient,
			}"
		>
			<fade-transition :duration="200" origin="center top" mode="out-in">
				<router-view></router-view>
			</fade-transition>
		</main>
	</div>
</template>
<script>
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

function hasElement(className) {
	return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
	if (hasElement(className)) new PerfectScrollbar(`.${className}`);
	else setTimeout(() => initScrollbar(className), 100);
}

import DashboardNavbar from "../components/app/DashboardNavbar.vue";
import ContentFooter from "../components/app/ContentFooter.vue";
import DashboardContent from "../components/app/Content.vue";
import { FadeTransition } from "vue2-transitions";
import { mapActions, mapGetters } from 'vuex';

export default {
	name: 'DashboardLayout',
	components: {
		DashboardNavbar,
		ContentFooter,
		DashboardContent,
		FadeTransition
	},
	data: () => ({
		isLoggingOut: false,
		routes: [
			{
				name: 'Inicio',
				path: '/inicio',
				icon: 'ni ni-air-baloon text-yellow'
			},
			{
				name: 'Asignaciones',
				path: '/assignments',
				icon: 'ni ni-single-02 text-orange'
			},
			{
				name: 'Solicitudes',
				path: '/requests',
				icon: 'ni ni-single-02 text-orange'
			},
			{
				name: 'Clientes',
				path: '/auc',
				icon: 'fas fa-user-tie'
			},
			// {
			// 	name: 'Usuarios',
			// 	path: '/users',
			// 	icon: 'fas fa-users'
			// },
			{
				name: 'Peritos',
				path: '/pa',
				icon: 'fas fa-user-tie'
			},
			{
				name: 'Referencia de Mercado',
				path: '/refmercado',
				icon: 'ni ni-pin-3 text-primary'
			},
			{
				name: 'Mapa de Calor',
				path: '/heatmap',
				icon: 'ni ni-pin-3 text-info'
			},
			{
				name: 'Estado de Avalúos',
				path: '/appraisals',
				icon: 'ni ni-bullet-list-67 text-red'
			}
		]
	}),
	computed: {
		...mapGetters('auth', [
			'$isAdmin',
			'$isClient',
			'$isExpertAdmin',
			'$isExpertClient',
		]),
		roleRoutes() {
			if (this.$isExpertAdmin) {
				return this.getRoutes(
					'Inicio', 'Asignaciones'
				)
			}
			if (this.$isAdmin) {
				return this.getRoutes(
					'Inicio', 'Solicitudes', 'Usuarios', 'Clientes',
					'Referencia de Mercado', 'Mapa de Calor',
					// 'Estado de Avalúos'
				)
			}
			if (this.$isClient) {
				return this.getRoutes(
					'Inicio', //'Asignaciones',
					'Referencia de Mercado', 'Mapa de Calor',
					'Estado de Avalúos', 'Peritos'
				)
			}
			if (this.$isExpertClient) {
				return this.getRoutes(
					'Inicio', 'Asignaciones'
				)
			}
			return this.routes
		}
	},
	methods: {
		...mapActions('auth', ['logout']),
		async onClickLogout() {
			this.isLoggingOut = true
			await this.logout()
			this.isLoggingOut = false
		},
		getRoutes(...names) {
			return this.routes.filter(
				route => names.includes(route.name)
			)
		},
		initScrollbar() {
			let isWindows = navigator.platform.startsWith("Win");
			if (isWindows) {
				initScrollbar("sidenav");
			}
		},
		setPrimaryColor() {
			let primary = '#10B981'
			if (this.$isExpertAdmin) primary = "#3B82F6"
			if (this.$isAdmin) primary = "#10B981"
			if (this.$isClient) primary = "#EC4899"
			if (this.$isExpertClient) primary = "rgba(239, 68, 68)"
			document.body.style = `--primary:${primary};`
		}
	},
	mounted() {
		this.initScrollbar();
		this.setPrimaryColor()
	}
};
</script>
